module.exports = __webpack_public_path__ + "img/info_4.2e6ac534.png";